"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COLUMN_OPTIONS = exports.NEW_ROW_PREFIX = exports.COLNAME_ROW_MENU = exports.COLNAME_FILL_SPACE = exports.COLNAME_ROW_SELECTOR = exports.COLNAME_ROW_DETAILS = exports.COLNAME_ROW_HEADER = void 0;
exports.COLNAME_ROW_HEADER = '$ROW_HEADER';
exports.COLNAME_ROW_DETAILS = '$ROW_DETAILS';
exports.COLNAME_ROW_SELECTOR = '$ROW_SELECTOR';
exports.COLNAME_FILL_SPACE = '$ROW_FILL_SPACE';
exports.COLNAME_ROW_MENU = '$ROW_MENU';
exports.NEW_ROW_PREFIX = '$$newrow$$_';
exports.DEFAULT_COLUMN_OPTIONS = {
    editable: true,
    resizable: true,
    frozen: false
};
//# sourceMappingURL=constants.js.map